import { render } from "./AppButton.vue?vue&type=template&id=ec5ea74a&scoped=true&ts=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=ec5ea74a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5ea74a"]])

export default __exports__